import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Small back arrow for tab pages (Profile/Matches/Messages/Settings).
// Always renders — uses navigate(-1) when history exists, otherwise falls back
// to a sensible in-app route so the user is never trapped.
export default function BackNavButton({ className = '', fallback = '/discover' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = typeof window !== 'undefined' && window.history.length > 1;

  const onBack = () => {
    if (hasHistory) {
      try { navigate(-1); return; } catch {}
    }
    navigate(fallback, { replace: true });
  };

  // Don't render on the landing/auth pages (safety)
  if (['/', '/auth'].includes(location.pathname)) return null;

  return (
    <button
      onClick={onBack}
      data-testid="back-nav-btn"
      aria-label="Go back"
      className={`w-9 h-9 rounded-full bg-white/90 border border-[var(--hairline-strong)] hover:bg-black/[0.03] flex items-center justify-center transition-colors ${className}`}
    >
      <ArrowLeft size={16} className="text-[#0F0F10]" strokeWidth={2.2} />
    </button>
  );
}
